<template>
  <stats-card v-loading="loading" title="Tempo médio de quitação" type="danger" :sub-title="`${value}`" icon="ni ni-time-alarm">
  </stats-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  data()  {
    return {
      value: '',
      loading: false
    }
  },
  computed: {
    ...mapState('client',['averagePaymentTime']),
    
  },
  methods: {
    ...mapActions('client',['getAveragePaymentTime'])
  },
  async mounted() {
    this.loading = true
    await this.getAveragePaymentTime()
    this.loading = false
    this.value = this.averagePaymentTime ? `${this.averagePaymentTime} dia(s)` : '0'

  }
}
</script>

<style scoped>

</style>